import { defineComponent as I, createElementBlock as m, createCommentVNode as o, openBlock as i, Fragment as C, withModifiers as a, normalizeClass as k, createTextVNode as $, createBlock as d, toDisplayString as r, capitalize as h, unref as n, withCtx as v, createVNode as y, createElementVNode as u } from "vue";
import { ScalarButton as g } from "@scalar/components";
import { ScalarIconEye as f, ScalarIconPencil as w } from "@scalar/icons";
const E = ["href"], S = ["href"], M = /* @__PURE__ */ I({
  __name: "HeaderItemTab",
  props: {
    tab: {},
    isEditable: { type: Boolean },
    isMobile: { type: Boolean },
    linkIsActive: { type: Function },
    resolveInternalLinks: { type: Function }
  },
  emits: ["navigate", "toggleShow", "editOpenAPIDocument"],
  setup(e, { emit: c }) {
    const s = c;
    return (b, t) => e.tab.show || e.isEditable ? (i(), m(C, { key: 0 }, [
      e.isMobile ? (i(), m("a", {
        key: 0,
        class: k(["header-item-link", {
          "header-item-active": e.linkIsActive(e.tab),
          "header-item-ghost": !e.tab.show
        }]),
        href: e.resolveInternalLinks(e.tab),
        onClick: t[2] || (t[2] = a((l) => b.$emit("navigate", e.tab.uid, e.tab.type), ["prevent"]))
      }, [
        $(r(e.tab.title || h(e.tab.type)) + " ", 1),
        !e.tab.show && e.isEditable ? (i(), d(n(g), {
          key: 0,
          class: "header-item-show-button",
          variant: "ghost",
          onClick: t[0] || (t[0] = a((l) => b.$emit("toggleShow", e.tab.uid, e.tab.type), ["stop"]))
        }, {
          default: v(() => [
            y(n(f)),
            t[6] || (t[6] = u("span", null, "Show", -1))
          ]),
          _: 1
        })) : o("", !0),
        e.isEditable && e.tab.type === "reference" && e.tab.hasManagedDoc ? (i(), d(n(w), {
          key: 1,
          weight: "fill",
          onClick: t[1] || (t[1] = a((l) => s("editOpenAPIDocument"), ["stop"]))
        })) : o("", !0)
      ], 10, E)) : (i(), m("a", {
        key: 1,
        class: k(["header-item-link", {
          "header-item-active": e.linkIsActive(e.tab),
          "header-item-ghost": !e.tab.show
        }]),
        href: e.resolveInternalLinks(e.tab),
        onClick: t[5] || (t[5] = a((l) => b.$emit("navigate", e.tab.uid, e.tab.type), ["prevent"]))
      }, [
        u("span", null, r(e.tab.title || h(e.tab.type)), 1),
        !e.tab.show && e.isEditable ? (i(), d(n(g), {
          key: 0,
          class: "header-item-show-button",
          variant: "ghost",
          onClick: t[3] || (t[3] = a((l) => b.$emit("toggleShow", e.tab.uid, e.tab.type), ["stop"]))
        }, {
          default: v(() => [
            y(n(f), { weight: "fill" }),
            t[7] || (t[7] = u("span", null, "Show", -1))
          ]),
          _: 1
        })) : o("", !0),
        e.isEditable && e.tab.type === "reference" && e.tab.hasManagedDoc ? (i(), d(n(w), {
          key: 1,
          weight: "fill",
          onClick: t[4] || (t[4] = a((l) => s("editOpenAPIDocument"), ["stop"]))
        })) : o("", !0)
      ], 10, S))
    ], 64)) : o("", !0);
  }
});
export {
  M as default
};
